import { required } from "react-admin";
import { Grid, FormControlLabel, Switch } from "@mui/material";
import { SectionTitle } from "features/SectionTitle";

// import { GenderOptionsId, PersonIdTypes } from "utils/choices";
// import CustomDateInput from "server/components/Fields/CustomDateInput";
import EmployeeInput from "server/components/Fields/EmployeeInput";
import { settings } from "app";
// import { useEffect, useState } from "react";
// import { useFormContext } from "react-hook-form";

const InfoForm = ({ isMobile, isEmployee, setIsEmployee }) => {
  // const { setValue } = useFormContext();
  // const handleChange = event => {
  //   setIsEmployee(event.target.checked);
  //   if (event.target.checked) {
  //   }
  // };
  // useEffect(() => {
  //   if (isEmployee) {
  //     setValue("userInfoCandidate", {
  //       firstName: "",
  //       secondName: "",
  //       lastName: "",
  //       email: "",
  //       contactPhone: "",
  //       birthDate: null,
  //       gender: "",
  //       personIdType: "",
  //       personId: "",
  //     });
  //   } else {
  //     setValue("employeeId", null);
  //   }
  // }, [isEmployee]);

  return (
    <Grid
      container
      spacing={2}
      sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
    >
      <Grid
        item
        xs={12}
      >
        <SectionTitle
          title={"Информация за кандидата"}
          paddingY={0}
        />
      </Grid>
      <Grid
        item
        xs={12}
      >
        <FormControlLabel
          control={
            <Switch
              checked={isEmployee}
              disabled
              // onChange={handleChange}
            />
          }
          label="Съществуващ служител на МУ София"
        />
      </Grid>
      {/* {isEmployee ? ( */}
      <Grid
        item
        xs={12}
        md={6}
        xl={4}
      >
        <EmployeeInput
          source="employeeId"
          validate={[required()]}
        />
      </Grid>
      {/* ) : (
        <>
          <Grid
            item
            xs={12}
          >
            <SectionTitle paddingY={2} title={"Информация за кандидата"} />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            {" "}
            <TextInput
              source="userInfoCandidate.firstName"
              label="Име"
              validate={[required()]}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            {" "}
            <TextInput
              source="userInfoCandidate.secondName"
              label="Презиме"
              validate={[required()]}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            {" "}
            <TextInput
              source="userInfoCandidate.lastName"
              label="Фамилия"
              validate={[required()]}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            <TextInput
              label="Имейл"
              source="userInfoCandidate.email"
              validate={[required(), email()]}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            <TextInput
              source="userInfoCandidate.contactPhone"
              label="Телефон"
              validate={[required(), regex(/^(359|0){1}[0-9]{9}$/, "Моля въведете валиден телефон")]}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            <SelectInput
              label="Пол"
              source="userInfoCandidate.gender"
              choices={GenderOptionsId}
              validate={[required()]}
              fullWidth
            />
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            <SelectInput
              source="userInfoCandidate.personIdType"
              choices={PersonIdTypes}
              label="Тип идентификатор"
              validate={required("Задължително")}
            />
          </Grid>
          <FormDataConsumer>
            {({ formData, scopedFormData }) => {
              return (
                <Grid
                  item
                  xs={12}
                  md={6}
                  xl={4}
                >
                  <TextInput
                    label={
                      PersonIdTypes.find(x => x.id === formData.userInfoCandidate?.personIdType)?.name ||
                      "Идентификатор"
                    }
                    source="userInfoCandidate.personId"
                    validate={required("Задължително")}
                    fullWidth
                  />
                </Grid>
              );
            }}
          </FormDataConsumer>
          <Grid
            item
            xs={12}
            md={6}
            xl={4}
          >
            <CustomDateInput
              fullWidth
              source="userInfoCandidate.birthDate"
              label="Дата на раждане"
              validate={required("Задължително")}
              required
            />
          </Grid>
        </>
      )} */}
    </Grid>
  );
};
export default InfoForm;
